import request from '@/utils/request'

// 获取直播间列表
export function getLiveList(query) {
  return request({
    url: '/app-api/service/live/getLiveList/v1_0_0',
    method: 'get',
    params: query
  })
}
// 获取直播间分类
export function getLiveCategoryList(query) {
  return request({
    url: '/app-api/service/live/getLiveCategoryList/v1_0_0',
    method: 'post',
    params: query
  })
}
// 获取直播间在线用户列表
export function getChatRoomOnlineUserList(query) {
  return request({
    url: '/app-api/service/live/getChatRoomOnlineUserList/v1_0_0',
    method: 'get',
    params: query
  })
}
// 获取直播间在线用户总数
export function getChatRoomOnlineUserCount(query) {
  return request({
    url: '/app-api/service/live/getChatRoomOnlineUserCount/v1_0_0',
    method: 'get',
    params: query
  })
}
// 获取直播间常用语列表
export function getLiveCommonExpressionsList(query) {
  return request({
    url: '/app-api/service/live/getLiveCommonExpressionsList/v1_0_0',
    method: 'get',
    params: query
  })
}
// 获取直播间详情
export function getChatRoomDetails(query) {
  return request({
    url: '/app-api/service/live/getChatRoomDetails/v1_0_0',
    method: 'get',
    params: query
  })
}
// 直播间发送普通消息
export function chatRoomSendMsg(data) {
  return request({
    url: '/app-api/service/live/chatRoomSendMsg/v1_0_0',
    method: 'post',
    data: data
  })
}
// 获取礼物列表
export function getGiftList(query) {
  return request({
    url: '/app-api/service/live/getGiftList/v1_0_0',
    method: 'get',
    params: query
  })
}
// 赠送礼物
export function giveGift(data) {
  return request({
    url: '/app-api/service/live/giveGift/v1_0_0',
    method: 'post',
    data: data
  })
}
// 开始直播
export function startLive(data) {
  return request({
    url: '/app-api/service/live/startLive/v1_0_0',
    method: 'post',
    data: data
  })
}
// 添加直播间常用语
export function addLiveCommonExpressions(data) {
  return request({
    url: '/app-api/service/live/addLiveCommonExpressions/v1_0_0',
    method: 'post',
    data: data
  })
}
// 删除直播间常用语
export function delLiveCommonExpressions(data) {
  return request({
    url: '/app-api/service/live/delLiveCommonExpressions/v1_0_0',
    method: 'post',
    data: data
  })
}
// 获取直播间管理员用户信息列表(仅房主)
export function getChatRoomAdminUserList(query) {
  return request({
    url: '/app-api/service/live/getChatRoomAdminUserList/v1_0_0',
    method: 'get',
    params: query
  })
}
// 添加管理员(仅房主可操作)
export function addAdmin(data) {
  return request({
    url: '/app-api/service/live/addAdmin/v1_0_0',
    method: 'post',
    data: data
  })
}
// 移除管理员(仅房主可操作)
export function delAdmin(data) {
  return request({
    url: '/app-api/service/live/delAdmin/v1_0_0',
    method: 'post',
    data: data
  })
}
// 获取直播间用户详情
export function getChatRoomUserDetails(query) {
  return request({
    url: '/app-api/service/live/getChatRoomUserDetails/v1_0_0',
    method: 'get',
    params: query
  })
}
// 获取用户直播记录
export function getUserLiveRecordList(query) {
  return request({
    url: '/app-api/service/user/getUserLiveRecordList/v1_0_0',
    method: 'get',
    params: query
  })
}
// 禁言用户(仅房主和管理员操作)
export function bannedToPostUser(data) {
  return request({
    url: '/app-api/service/live/bannedToPostUser/v1_0_0',
    method: 'post',
    data: data
  })
}
// 解除禁言用户(仅房主和管理员操作)
export function relieveBannedToPostUser(data) {
  return request({
    url: '/app-api/service/live/relieveBannedToPostUser/v1_0_0',
    method: 'post',
    data: data
  })
}
// 将用户踢出直播间(仅主持人和管理员操作)
export function kickOutChatRoom(data) {
  return request({
    url: '/app-api/service/live/kickOutChatRoom/v1_0_0',
    method: 'post',
    data: data
  })
}
// 修改公告(仅房主和管理员操作)
export function updNotice(data) {
  return request({
    url: '/app-api/service/live/updNotice/v1_0_0',
    method: 'post',
    data: data
  })
}
//获取直播间商品列表
export function getGoodsList(query) {
  return request({
    url: '/app-api/service/live/getGoodsList/v1_0_0',
    method: 'get',
    params: query
  })
}
// 提交订单
export function submitOrder(data) {
  return request({
    url: '/app-api/service/live/submitOrder/v1_0_0',
    method: 'post',
    data: data
  })
}
//获取用户订单列表
export function getUserOrderList(query) {
  return request({
    url: '/app-api/service/live/getUserOrderList/v1_0_0',
    method: 'get',
    params: query
  })
}


// WEBPACK FOOTER //
// ./src/api/zhibo.js